export const UPDATE_MEDICAL_PLAN = "UPDATE_MEDICAL_PLAN";
export const REQUEST_MEDICAL_PLAN_UPDATE = "REQUEST_MEDICAL_PLAN_UPDATE";
export const updateMedicalPlan = (plan) => ({
  type: UPDATE_MEDICAL_PLAN,
  plan,
});
export const requestMedicalPlanUpdate = () => ({
  type: REQUEST_MEDICAL_PLAN_UPDATE,
});
